import { add, listen, qsa, remove } from "@fluorescent/dom";

import { section } from "@/neon";

section("addresses", {
  onLoad() {
    this.modals = qsa("[data-modal]", this.container);

    const overlays = qsa("[data-overlay]", this.container);
    const open = qsa("[data-open]", this.container);
    const close = qsa("[data-close]", this.container);
    const remove = qsa("[data-remove]", this.container);
    const countryOptions = qsa("[data-country-option]", this.container) || [];

    this.events = [
      listen(open, "click", e => this.openModal(e)),
      listen([...close, ...overlays], "click", e => this.closeModal(e)),
      listen(remove, "click", e => this.removeAddress(e)),
    ];

    countryOptions.forEach(el => {
      const { formId } = el.dataset;

      const countrySelector = "AddressCountry_" + formId;
      const provinceSelector = "AddressProvince_" + formId;
      const containerSelector = "AddressProvinceContainer_" + formId;

      new window.Shopify.CountryProvinceSelector(
        countrySelector,
        provinceSelector,
        {
          hideElement: containerSelector,
        }
      );
    });
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },

  openModal(e) {
    e.preventDefault();
    const { open: which } = e.currentTarget.dataset;

    const modal = this.modals.find(el => el.dataset.modal == which);
    add(modal, "active");
    setTimeout(() => {
      add(modal, "visible");
    }, 50);
  },

  closeModal(e) {
    e.preventDefault();
    remove(this.modals, "visible");
    setTimeout(() => {
      remove(this.modals, "active");
    }, 350);
  },

  removeAddress(e) {
    const { confirmMessage, target } = e.currentTarget.dataset;
    if (
      confirm(confirmMessage) ||
      "Are you sure you wish to delete this address?"
    ) {
      window.Shopify.postLink(target, {
        parameters: { _method: "delete" },
      });
    }
  },
});
